import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import 'src/styles/pages/_accountsPayable.scss';
import ProspectStaff from 'src/models/projectSettings/TsdiProspectStaff';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import CalendarDay from 'src/models/AP/CalendarDay';
import DayEntry from 'src/models/AP/DayEntry';
import BillingCode from 'src/models/AP/BillingCode';
import DayEntryComponent from '../components/DayEntryComponent';

interface IWorkAndExpenseDialogProps {
    dialogName: string;
    handleSelectedPerson?: (person: ProspectStaff) => void;
    hideDialog: () => void;
    setPersonSearchTerm?: (keyword: string) => void;
    createMode?: boolean;
    payPeriods?: Array<{value: number | string, label: string}>;
    workClassifications?: Array<{value: number | string, label: string}>;
    setSelectedProjectStaff?: (staffer: ProspectStaff) => void;
    project?: ProspectDetails;
    calendarDays?: Array<CalendarDay>;
    billingCode?: BillingCode;
    activityType?: string;
    compType?: string;
    payPeriod?: number;
    dayEntries?: Array<DayEntry>;
    hasReceipts?: (value: boolean) => void;
    adminToUser?: boolean;
    confirmDeleteDayEntry?: boolean;
    selectedSummaryIndex?: number;
    setShowDeleteWarning?: (value: object) => void;
}

const WorkAndExpenseDialog = (props: IWorkAndExpenseDialogProps) => {
    const { register, getValues, setValue } = useForm();
    const [selectedIndex, setSelectedIndex] = useState<number>(undefined);
    const [tmIdToDelete, setTmIdToDelete] = useState<number>(undefined);
    const [calendarDays, setCalendarDays] = useState<Array<CalendarDay>>(undefined);

    useEffect(() => {
      onCreate();
    }, []);

    useEffect(() => {
        if (Array.isArray(props?.calendarDays) && props?.calendarDays.length > 0) {
          setCalendarDays(props.calendarDays);
        }
    }, [props?.calendarDays]);

    useEffect(() => {
        if (props?.selectedSummaryIndex !== undefined && props?.selectedSummaryIndex !== null) {
          setSelectedIndex(props?.selectedSummaryIndex);
        }
    }, [props?.selectedSummaryIndex]);

    const onCreate = () => {
        setSelectedIndex(0);
        console.log('FindPersonDialog onCreate()');
    };

    const closeDialog = () => {
        props.hideDialog();
    };

    const getDayEntriesForCalendarDayIndex = (calendarDayIndex: number) => {
        let dayEntries: DayEntry[] | undefined = undefined;
        const bc = Object.assign(new BillingCode(), props.billingCode);
        let targetBillingCodeString = bc.toString();
        if (calendarDays[calendarDayIndex]?.dayEntries && calendarDays[calendarDayIndex]?.dayEntries?.length > 0) {
          dayEntries = calendarDays[calendarDayIndex]?.dayEntries.filter(
            (de) => {
              const clientNumber = de?.clientNumber ? de.clientNumber : 0;
              const projectNumber = de?.prospectNumber ? de.prospectNumber : 0;
              const sectionNumber = de?.sectionNumber ? de.sectionNumber : 0;
              const unitNumber = de?.unitNumber ? de.unitNumber : 0;
              const compareBillingCodeString = `${clientNumber}.${projectNumber}.${sectionNumber}.${unitNumber}`;
              return compareBillingCodeString === targetBillingCodeString &&
                de.selectedAccountCodeContainer?.name === props.billingCode.activityType;
            });
        }
        return dayEntries;
    };

    const displayTimeEntries = () => {
        return calendarDays?.map((day: CalendarDay, index: number) => {
          let dayEntries = getDayEntriesForCalendarDayIndex(index);
          return dayEntries?.map((dayEntry: DayEntry) => {
            let previousDayEntryIndex: number = -1;
            let dayEntryIndex: number = -1;
            if (dayEntry !== undefined) {
              dayEntryIndex = day.dayEntries.indexOf(dayEntry);
            }

            return (
              <React.Fragment key={`${index}-${day.id}-${day?.totalHours ?? 1}`}>
                <DayEntryComponent
                  closeDialog={closeDialog}
                  selectedIndex={selectedIndex}
                  editTimeline={null}
                  calendarDays={calendarDays}
                  editedDayEntryIndex={previousDayEntryIndex}
                  register={register}
                  setValue={setValue}
                  getValues={getValues}
                  isValidDayEntry={() => { console.log('not implemented'); }}
                  calendarDay={day}
                  calendarDayIndex={index}
                  dayEntry={dayEntry}
                  dayEntryIndex={dayEntryIndex}
                  compType={props?.compType}
                  adminToUser={props?.adminToUser}
                  payperiod={props?.payPeriod.toString()}
                  hasReceipts={props?.hasReceipts}
                  setShowDeletWarning={props?.setShowDeleteWarning}
                  confirmedDeleteDayEntry={props?.confirmDeleteDayEntry}
                  setTmIdToDelete={setTmIdToDelete}
                  tmidToDelete={tmIdToDelete}
                />
              </React.Fragment>
            );
          });
        });
      };

    return (
        <Dialog title={'Time & Expenses'} dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{backgroundColor: 'white', width: '75%' }}>
            <div className="tw-form-row" style={{marginTop: '1rem', display: 'inline-block', whiteSpace: 'nowrap', justifyContent: 'flex-start'}}>
        <div className="tw-w-full">
          <div className="tw-text-center tw-text-xl tw-font-semibold">
            <h2>
              {`Billing Code: ${props?.billingCode?.clientNumber}.${props?.billingCode?.prospectNumber}.${props?.billingCode?.sectionNumber}.${props?.billingCode?.unitNumber}`}
            </h2>
            <h2>
              {`Activity Type: ${props?.activityType}`}
            </h2>
          </div>
          <div className="mt-6 tw-grid tw-grid-cols-[200px_200px_auto_150px] tw-gap-y-4">
            <h3 className="tw-text-center tw-text-m tw-font-semibold tw-underline">
              Date/Time
            </h3>
            <h3 className="text-center text-m font-semibold underline col-span-3">
              Work Description/Expenses
            </h3>
            <div className="tw-col-span-4 tw-overflow-y-auto tw-max-h-[63vh]">
              <div className="tw-grid tw-grid-cols-[200px_950px_150px]">
                {calendarDays &&
                  !!props?.billingCode &&
                  displayTimeEntries()}
              </div>
            </div>
          </div>
        </div>
            </div>
        </Dialog>
    );
};

export default WorkAndExpenseDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/WorkDescriptionsAndExpensesDialog.tsx